import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { khoanNopGroupApi } from "../../../api/dich-vu/khoanNopGroupApi";
import { saleSetRegisterDichVuApi } from "../../../api/dich-vu/saleSetRegisterDichVuApi";
import { IBaseResponeModel } from "../../../models/response/base-response";
import {
	eSaleSetRegisterDichVuActionTypeIds,
	IKhoanNopGroupByHocSinhLoadStart,
	ISaleSetRegisterDichVuLoadStart,
	ISaleSetRegisterDichVuSaveStart
} from "../../action-types/dich-vu/ISaleSetRegisterDichVuActionTypes";
import { saleSetRegisterDichVuActions } from "../../actions/dich-vu/saleSetRegisterDichVuActions";

export function* saleSetRegisterDichVuSaga(): any {
	yield takeLatest(eSaleSetRegisterDichVuActionTypeIds.LOAD_START, loadSaleSetRegisterDichVuWorker)
	yield takeLatest(eSaleSetRegisterDichVuActionTypeIds.LOAD_KHOANNOP_BY_HOCSINH_START, loadKhoanNopGroupByHocSinhWorker)
	yield takeEvery(eSaleSetRegisterDichVuActionTypeIds.SAVE_START, saveSaleSetRegisterDichVuWorker)
}

function* loadSaleSetRegisterDichVuWorker(action: ISaleSetRegisterDichVuLoadStart): any {
	const res: IBaseResponeModel = yield call([saleSetRegisterDichVuApi, saleSetRegisterDichVuApi.SelectByCoSo], action.payload)
	if (res.is_success) {
		yield put(saleSetRegisterDichVuActions.loadSaleSetRegisterDichVuSuccess(res.data || []))
	} else {
		yield put(saleSetRegisterDichVuActions.loadSaleSetRegisterDichVuError(res.message || "Không tải được danh sách đăng ký dịch vụ"))
	}
}

function* loadKhoanNopGroupByHocSinhWorker(action: IKhoanNopGroupByHocSinhLoadStart): any {
	const res: IBaseResponeModel = yield call([khoanNopGroupApi, khoanNopGroupApi.SelectByHocSinh], action.payload)
	if (res.is_success) {
		yield put(saleSetRegisterDichVuActions.loadKhoanNopGroupByHocSinhSuccess(res.data || []))
	} else {
		yield put(saleSetRegisterDichVuActions.loadKhoanNopGroupByHocSinhError(res.message || "Không tải được danh sách khoản nộp của học sinh"))
	}
}

function* saveSaleSetRegisterDichVuWorker(action: ISaleSetRegisterDichVuSaveStart): any {
	const res: IBaseResponeModel = yield call([saleSetRegisterDichVuApi, saleSetRegisterDichVuApi.InsertMultiple], action.payload)
	if (res.is_success) {
		yield put(saleSetRegisterDichVuActions.saveSaleSetRegisterDichVuSuccess())
	} else {
		yield put(saleSetRegisterDichVuActions.saveSaleSetRegisterDichVuError(res.message || "Không lưu được đăng ký dịch vụ"))
	}
}
